import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { APP_CONFIG } from '../../config/app-config';
import { buildApiUrl } from '../api-http/form-url-encoded';

export interface AdminModule { idmodulo: number; modulo: string; idestatus: number; }
export interface AdminLocation { idlocacion: number; nombre: string; idestatus?: number; puntoventa?: number | boolean; }
export interface AdminReport { idreporte: number; reporte: string; descripcion?: string; idestatus: number; }
export interface AdminUser { idusuario: number; user: string; nombre: string; idestatus: number; modulos: number[]; locaciones: number[]; reportes: number[]; }
export interface AdminUsersSnapshot { usuarios: AdminUser[]; modulos: AdminModule[]; locaciones: AdminLocation[]; reportes: AdminReport[]; }
export interface UserProfile { idusuario: number; user: string; nombre: string; }

@Injectable()
export class AdminUsuariosProvider {
  constructor(private http: HttpClient) {}

  load(apiKey: string): Promise<AdminUsersSnapshot> { return this.request('get', apiKey, 'bootstrap'); }
  save(apiKey: string, id: number | null, body: any): Promise<any> { return this.request(id === null ? 'post' : 'put', apiKey, 'usuarios' + (id === null ? '' : '/' + id), body); }
  regenerateTemporaryPassword(apiKey: string, id: number): Promise<any> { return this.request('post', apiKey, 'usuarios/' + id + '/password-temporal', {}); }
  profile(apiKey: string): Promise<UserProfile> { return this.request('get', apiKey, 'perfil'); }
  changeOwnPassword(apiKey: string, passwordActual: string, passwordNueva: string): Promise<any> { return this.request('put', apiKey, 'mi-password', { passwordActual, passwordNueva }); }

  private request(method: 'get' | 'post' | 'put', apiKey: string, path: string, body?: any): Promise<any> {
    if (!apiKey) { return Promise.reject(new Error('La sesión no está disponible.')); }
    const apiPath = 'admin-usuarios/' + path + (method === 'get' ? (path.indexOf('?') === -1 ? '?' : '&') + '_=' + Date.now() : '');
    const url = buildApiUrl(APP_CONFIG.apiBaseUrl, apiPath);
    const options = { headers: new HttpHeaders({ Authorization: apiKey, 'Content-Type': 'application/json' }) };
    const request = method === 'get' ? this.http.get<any>(url, options) : this.http[method]<any>(url, body, options);
    return request.toPromise().then(response => {
      if (!response || String(response.code) === '1') { throw new Error(response && response.message ? response.message : 'No fue posible completar la operación.'); }
      return response.data;
    }).catch(error => {
      if (error instanceof Error) { return Promise.reject(error); }
      return Promise.reject(new Error(error && error.error && error.error.message ? error.error.message : 'No fue posible conectar con la administración de usuarios.'));
    });
  }
}



// WEBPACK FOOTER //
// ./src/providers/admin-usuarios/admin-usuarios.ts